import { Fragment, ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import {
    GeneralBlock,
    GeneralBlockBody,
    GeneralBlockHeader,
    GeneralBlockTitle,
    GeneralBlockValue,
} from 'src/registry/components/blocks/GeneralBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';
import { SectionBlockBody, SectionBlockSeparator } from 'src/registry/components/blocks/SectionBlock';
import { cn } from 'src/utils';

type Section = {
    title: { id: string; defaultMessage: string };
    value: string | ReactNode;
    isLoading?: boolean;
};
type DashboardGeneralBlockProps = {
    dashboardData: Record<string, Section[]>;
    indexForLastSeparator: number;
    className?: string;
};
const DashboardGeneralBlock = ({ dashboardData, indexForLastSeparator, className }: DashboardGeneralBlockProps) => (
    <GeneralBlock asChild className={cn(className, className)}>
        <SectionBlockBody>
            {Object.entries(dashboardData).map(([sectionName, items], index) => (
                <Fragment key={sectionName}>
                    <div
                        key={sectionName}
                        className={cn(
                            'xs:grid-cols-1 relative grid h-full gap-4 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4',
                        )}
                    >
                        {items.map(({ title, value, isLoading }) => {
                            return (
                                <div className="flex flex-col" key={title.id}>
                                    <GeneralBlockHeader variant="dashboard">
                                        <GeneralBlockTitle>
                                            <FormattedMessage {...title} />
                                        </GeneralBlockTitle>
                                    </GeneralBlockHeader>
                                    <GeneralBlockBody variant="dashboard">
                                        {isLoading ? (
                                            <Skeleton className="h-8 w-full max-w-48" />
                                        ) : (
                                            <GeneralBlockValue size="small" className="break-all">
                                                {value}
                                            </GeneralBlockValue>
                                        )}
                                    </GeneralBlockBody>
                                </div>
                            );
                        })}
                    </div>
                    {index !== indexForLastSeparator && <SectionBlockSeparator />}
                </Fragment>
            ))}
        </SectionBlockBody>
    </GeneralBlock>
);

export default DashboardGeneralBlock;
